import styled from "styled-components";

interface ToggleButtonProps {
  options: { value: string | number | boolean; label: string }[];
  value: string | number | boolean;
  onChange: (value: string | number | boolean) => void;
}

interface OptionBoxProps {
  selected: boolean;
  isLast: boolean;
  isFirst: boolean;
}

const OptionBox = styled.div<OptionBoxProps>`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  flex-grow: 1;
  font-size: 0.9rem;
  cursor: pointer;

  border-right: ${({ isLast }) => (isLast ? "none" : "1px solid lightgray")};

  border-top-left-radius: ${({ isFirst }) => (isFirst ? "0.35rem" : "0")};
  border-bottom-left-radius: ${({ isFirst }) => (isFirst ? "0.35rem" : "0")};
  border-top-right-radius: ${({ isLast }) => (isLast ? "0.35rem" : "0")};
  border-bottom-right-radius: ${({ isLast }) => (isLast ? "0.35rem" : "0")};

  background-color: ${({ selected }) =>
    selected ? "var(--bs-primary)" : "transparent"};

  color: ${({ selected }) => (selected ? "white" : "inherit")};
`;

const ToggleButton = ({ options, value, onChange }: ToggleButtonProps) => {
  return (
    <div
      className="h-100 w-100 d-flex flex-row rounded"
      style={{ border: "1px solid lightgray" }}
    >
      {options.map((option, index) => (
        <OptionBox
          onClick={() => onChange(option.value)}
          selected={option.value === value}
          isLast={index === options.length - 1}
          isFirst={index === 0}
          key={option.label}
        >
          <span>{option.label}</span>
        </OptionBox>
      ))}
    </div>
  );
};

export default ToggleButton;
